<template>
    <svg class="fill-current stroke-current" version="1.1" id="Camada_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 132.31 132.31" style="enable-background:new 0 0 132.31 132.31;" xml:space="preserve">
        <g>
            <path class="st4" d="M85.84,101.74H46.46c-5.51,0-9.98-4.47-9.98-9.98V40.55c0-5.51,4.47-9.98,9.98-9.98h39.38
                c5.51,0,9.98,4.47,9.98,9.98v51.21C95.82,97.27,91.36,101.74,85.84,101.74z"/>
            <path class="st1" d="M81.31,42.82H51c-1.46,0-2.65,1.19-2.65,2.65v30.31c0,1.46,1.19,2.65,2.65,2.65h30.31
                c1.46,0,2.65-1.19,2.65-2.65V45.47C83.96,44.01,82.77,42.82,81.31,42.82z"/>
            <path class="st2" d="M73.06,87.69H59.25c-1.37,0-2.48,1.11-2.48,2.48v0c0,1.37,1.11,2.48,2.48,2.48h13.82
                c1.37,0,2.48-1.11,2.48-2.48v0C75.54,88.8,74.43,87.69,73.06,87.69z"/>
        </g>
    </svg>
</template>
<style scoped type="text/css">
    .st1{fill:none;stroke:#606060;stroke-width:5;stroke-miterlimit:10;}
    .st4{fill:none;stroke:#606060;stroke-width:4.0965;stroke-miterlimit:10;}
</style>
